module.exports = __webpack_public_path__ + "img/user_href.c71cb627.svg";